import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { defaultUsageRange, fetchMyAiUsage, usageTotals } from './aiUsageModel';
export default function MyAiUsage() {
  const [data, setData] = useState(null);
  useEffect(() => { let alive = true; fetchMyAiUsage(defaultUsageRange()).then(next => { if (alive) setData(usageTotals(next.items)); }).catch(() => {}); return () => { alive = false; }; }, []);
  return data ? <div className="personal-settings-group"><Typography.Text>My AI use, last 30 days: {data.event_count} calls · {data.input_tokens + data.output_tokens} tokens · {data.estimated_cost_usd == null ? '—' : `$${Number(data.estimated_cost_usd).toFixed(6)}`}</Typography.Text></div> : null;
}
